/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentsDTO } from '../models/DocumentsDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomDocumentsResourceService {
    /**
     * @returns DocumentsDTO OK
     * @throws ApiError
     */
    public static createDocuments1({
        signallerId,
        requestBody,
    }: {
        /**
         * The id of the signaller to add documents
         */
        signallerId: number,
        requestBody: DocumentsDTO,
    }): CancelablePromise<DocumentsDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/custom/documents/addSignallerDocuments/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update of the signaller documents
     * Total update of signaller documents
     * @returns DocumentsDTO OK
     * @throws ApiError
     */
    public static updateDocuments1({
        signallerId,
        requestBody,
    }: {
        /**
         * The id of the signaller
         */
        signallerId: number,
        requestBody: DocumentsDTO,
    }): CancelablePromise<DocumentsDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/custom/documents/updateDoc/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the document dto requested
     * Retrieves the docs dto of requested signaller
     * @returns DocumentsDTO OK
     * @throws ApiError
     */
    public static findDocumentsBySignaller({
        signallerId,
    }: {
        /**
         * The id of the signaller
         */
        signallerId: number,
    }): CancelablePromise<DocumentsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/documents/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteDocumentsOfSignaller({
        signallerId,
    }: {
        /**
         * The id of the signaller documents to delete
         */
        signallerId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/custom/documents/deleteDocs/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
        });
    }
}
